export default __webpack_public_path__ + "static/media/upload-csv-icon.67e66610.svg";